import * as actionType from "../constants";

const initialState = {
  loading: false,
  active_boards: [],
  inactive_boards: [],
  loadcreate: false,
  message: "",
  status: "",
  show_board: false,
  code: "",
  attribute_set_name: "",
  nameboard: {},
};
const fetchAllBoards = (state = initialState, action) => {
  switch (action.type) {
    case actionType.BOARD_LOADING:
      return { ...state, loading: true };
    case actionType.ALL_BOARDS:
      return {
        loading: false,
        active_boards: action.payload.active_board,
        inactive_boards: action.payload.inactive_board,
      };
    case actionType.BOARD_ERROR:
      return { ...state, loading: false };
    case actionType.ADDING_SINGLE_BOARD:
      return { ...state, singeBoard: "", loadcreate: true };
    case actionType.CREATE_SINGLE_BOARD:
      return {
        loading: false,
        singleBoard: action.payload.board,
        active_boards: [...state.active_boards, { ...action.payload.board }],
        inactive_boards: [...state.inactive_boards],
        redirect: action.payload.redirect,
        loadcreate: false,
        message: action.payload.message,
        code: action.payload.code,
        status: action.payload.status,
        show_board: true,
      };
      break;
    case actionType.DELETE_BOARD:
      const activeboards = [...state.active_boards];
      const inactiveboardsdel = [...state.inactive_boards];
      const set_key = action.payload.data.attribute_set_key;
      const activeindex = activeboards.findIndex(
        (item) => item.attribute_set_key === set_key
      );
      if (activeindex > -1) {
        activeboards.splice(activeindex, 1);
      }
      const inactiveindex = inactiveboardsdel.findIndex(
        (item) => item.attribute_set_key === set_key
      );
      if (inactiveindex > -1) {
        inactiveboardsdel.splice(inactiveindex, 1);
      }
      return {
        ...state,
        active_boards: activeboards,
        redirect: 0,
        message: action.payload.message,
        status: action.payload.status,
        show_board: true,
        inactive_boards: inactiveboardsdel,
        code: action.payload.code,
      };
    case actionType.BOARD_RENAMING:
      return { ...state, loading: true };
    case actionType.BOARD_MESSAGE_DEACTIVATE:
      return { ...state, show_board: false, message: "", code: "" };
    case actionType.BOARD_RENAMED:
      const renaoards = [...state.active_boards];
      // console.log("ew board", renaoards);
      // console.log("old board", action);
      const ind = renaoards.findIndex(
        (board) =>
          board.attribute_set_key === action.payload.renameattr.attr_key
      );
      renaoards[ind].attribute_set_name = action.payload.renameattr.attr_name;
      const newac = {
        ...state,
        loading: false,
        active_boards: renaoards,
        ...action.payload,
        show_board: true,
        attribute_set_name: action.payload.renameattr.attr_name,
      };
      return {
        ...state,
        loading: false,
        active_boards: renaoards,
        ...action.payload,
        show_board: true,
      };
    case actionType.DEACTIVATE_BOARD:
      const allboard = [...state.active_boards];
      const index = allboard.findIndex(
        (keyy) => keyy.attribute_set_key === action.payload.key
      );
      allboard.splice(index, 1);
      const inactiveboards = [...state.inactive_boards, action.payload.data];
      return {
        ...state,
        active_boards: allboard,
        redirect: false,
        inactive_boards: inactiveboards,
        message: action.payload.message,
        status: action.payload.status,
        show_board: true,
        code: action.payload.code,
      };
    case actionType.ACTIVATE_BOARD:
      const allBoardsactgive = [...state.active_boards, action.payload.data];
      const boarddeactive = [...state.inactive_boards];
      const indexfind = boarddeactive.findIndex(
        (it) => it.attribute_set_key === action.payload.key
      );
      boarddeactive.splice(indexfind, 1);
      return {
        ...state,
        active_boards: allBoardsactgive,
        inactive_boards: boarddeactive,
        message: action.payload.message,
        status: action.payload.status,
        show_board: true,
        code: action.payload.code,
      };
    case actionType.RENAME_BOARD_ERROR:
      return {
        ...state,
        show_board: true,
        message: action.payload.message,
        status: action.payload.status,
        code: action.payload.code,
      };
    case actionType.REDIRECT_FALSE:
      return { ...state, redirect: false };
    case actionType.BOARD_MESSAGE_DEACTIVATE:
      return { ...state, show_board: false };
    case actionType.KEEP_STORE_BOARD_DETAILS:
      return { ...state, nameboard: { ...action.payload } };
    default:
      return state;
      break;
  }
};

export default fetchAllBoards;
